<template>
  <div> 
<md-card class="searchPanel">
  <md-card-content v-if="searchRequest">
    <md-dialog :md-active.sync="isFilterModalShowing" >
     
      <div> 
       <md-dialog-title>Filter</md-dialog-title>
        <md-button class="custButton md-raised icon1" @click="isFilterModalShowing = false" >Close</md-button>
        <md-button class="custButton md-primary md-raised icon1" @click="doSearch">Search</md-button>
     </div>
     <md-dialog-content>

      <div class = "inputBoxDouble" >

        <div class = "inputBoxSpace" >
          <md-field>
              <label>Mobile#</label>
              <md-input v-model="searchRequest.driverMobile"/>
          </md-field>
        </div>
<!--
        <div class = "inputBoxSpace" >
           <md-field>
              <label>LoadKey</label>
              <md-input v-model="searchRequest.seqNo"/>
          </md-field>
        </div>


      </div>

      <div class = "inputBoxDouble" >

        <div class = "inputBoxSpace" >
          <md-field>
             <label>Booking #</label>
             <md-input v-model="searchRequest.bookingNo"/>
         </md-field>
       </div>
           
       <div class = "inputBoxSpace" >
        <md-field>
           <label>IBD #</label>
           <md-input v-model="searchRequest.ibd"/>
        </md-field>
       </div>
      </div>

      <div class = "inputBoxDouble" >
        <div class = "inputBoxSpaceWide" >
        <auto-complete-master-data-select
                                              group="GST_CARRIER"
                                              label="Carrier"
                                              :init-value="searchRequest.carrier"
                                              :on-item-changed="handleCarrierChanged"
                                              >
        </auto-complete-master-data-select>
        </div>
      </div>
      <div class = "inputBoxDouble" >
      <div class = "inputBoxSpace" >
        <md-field>
          <label>Yard</label>
          <md-input v-model="searchRequest.transloadingYard" disabled/>
        </md-field>
      </div>

      <div class = "inputBoxSpace" >
        <md-field>
          <label>Seal#</label>
          <md-input v-model="searchRequest.sealNumber"/>
        </md-field>
      </div>
-->
      </div>



    </md-dialog-content>
    
  </md-dialog>
  


      <div class="md-layout md-gutter">
      <!--
        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox" >
            <auto-complete-master-data-select
                                              group="REC_WINDOW"
                                              label="Rev. Windows"
                                              :init-value="searchRequest.receivingWindows"
                                              :on-item-changed="handleWindowsChanged"
                                              >
          </auto-complete-master-data-select>
          </div>
        </div>

        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox" >
            <md-field>
                <label>Container#</label>
                <md-input v-model="searchRequest.containerNo"/>
            </md-field>
          </div>
        </div>



        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
            <datepicker v-model="searchRequest.gwDate.startDate">
              <label>GW Scale Date</label>
            </datepicker>
          </div>
        </div>
  
        <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox">
            <datepicker v-model="searchRequest.gwDate.endDate">
              <label>To</label>
            </datepicker>
          </div>
        </div>
  
        <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
          <div class = "inputBox" >
           <md-field>
              <label>Input WTicket</label>
              <md-input v-model="searchRequest.scanWt"/>
          </md-field>
          </div>      
        </div>

      <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
        <md-field>
          <label>IBS</label>
          <md-input v-model="searchRequest.ibs"/>
        </md-field>
        </div>
      </div>

      <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
     <div class = "inputBox">
        <auto-complete-master-data-select
                                      :prepared-options="getOutboundStatus"
                                      label="Status"
                                      :init-value="searchRequest.loadStatus"
                                      :on-item-changed="handleStatusChanged"
                                      >
        </auto-complete-master-data-select>
      </div>
      </div>
-->

      <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <datepicker v-model="startdate">
            <label>SMS Rec Date</label>
          </datepicker>
        </div>
      </div>

      <div  v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
          <datepicker v-model="enddate">
            <label>To</label>
          </datepicker>
        </div>
      </div>

      <div v-if="active" class="md-layout-item md-size-20 md-small-size-30">
        <div class = "inputBox">
        <md-field>
          <label>Search SMS Text</label>
          <md-input v-model="searchRequest.containMsg"/>
        </md-field>
        </div>
      </div>

            <div class="md-layout-item md-size-20 md-small-size-30" v-if="active">
              <div class="inputBoxOutbound">
               <auto-complete-master-data-select
                  label="Driver Name"
                  display-type="idOnly"
                  :prepared-options="drivers"
                  :init-value-id="this.searchRequest.shortId"
                  :watch-value-id="this.searchRequest.shortId"
                  :on-item-changed="handleDriverChanged()"
                  :createOption = "false"
                  :reverse = "true"
                  >
               </auto-complete-master-data-select>
              </div>
            </div>

     </div>   
   </md-card-content>   

   <md-card-actions md-alignment="space-between">
    <div class="md-layout-item md-size-100 md-small-size-100">
          <callingApiCenter path="/api/w/fsi/GetIBSOutbound" :not-display-error="true">               
              <md-button class="md-raised custMenuButton" @click="refreshAction">Refresh</md-button>
              <md-button id = "searchTag" class="md-raised custMenuButton md-primary" @click="doSearch">Search</md-button>
              <md-button class="md-raised custMenuButton" @click="doClear">Clear</md-button>
              <md-button class="md-raised custMenuButton" @click="filterBar"> Filter </md-button>

              <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
                <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
                <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
              </md-button>

          </callingApiCenter>
      </div>
  </md-card-actions>
    

 
</md-card>
            <callingApiCenter
              :paths="[
                '/api/w/SendSMS/GetRecLog',
                '/api/w/SendSMS/RefreshLog',
              ]"
            >

<pagination :items="filteredRows">
  <template slot-scope="{pageItems}">
    <md-card class="data-table-container">
      <div class="outer-container">
        <div class="inner-container">
          <div class="table-header">
            <table id="headertable">
              <thead>

                <th
                class="header-cell center w5"
                v-on:click="sortFunction('status')">
                Status
              </th>

              <th
                class="header-cell center w10"
                v-on:click="sortFunction('driverMobile')">
                Driver Mobile
              </th>
              <th
                class="header-cell center w5"
                v-on:click="sortFunction('shortId')">
                Driver Name
              </th>
              <th
                class="header-cell center w10"
                v-on:click="sortFunction('message')">
                message
              </th>
              <th
                class="header-cell center w10"
                v-on:click="sortFunction('sendDate')">
                Send/Rec Date
              </th>
              <th
                class="header-cell center w10"
                v-on:click="sortFunction('inboundShipment')">
                IBS
              </th>
              <th
                class="header-cell center w10"
                v-on:click="sortFunction('containerNo')">
                Container
              </th>
              <th
                class="header-cell center w15"
                v-on:click="sortFunction('messageId')">
                Message ID
              </th>
              <th
                class="header-cell center w15"
                v-on:click="sortFunction('messageId')">
                Source
              </th>

 

              </thead>
            </table>
          </div>
          <div class="table-body " @scroll="handleScroll">
            <table id="bodytable">
              <tbody>
                <tr :key="item.messageId" class="" v-for="item in pageItems">
                  <td class="body-cell excelBox w5" >
                    {{ item.status }}
                  </td>
                  <td class="body-cell excelBox w10">
                    {{ item.driverMobile }}
                  </td>
                  <td class="body-cell excelBox w5">
                    {{ item.shortId }}
                  </td>
                  <td class="body-cell excelBox w10">
                    {{ item.message }}
                  </td>
                  <td class="body-cell excelBox w10">
                    {{ item.sendDate }}
                  </td>
                  <td class="body-cell excelBox w10">
                    {{ item.inboundShipment }}
                  </td>
                  <td class="body-cell excelBox w10">
                    {{ item.containerNo }}
                  </td>
                  <td class="body-cell excelBox w15">
                    {{ item.messageId }}
                  </td>
                  <td class="body-cell excelBox w15">
                    {{ item.source }}
                  </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </md-card>
  </template>
</pagination>
</callingApiCenter>

</div>
</template>


<style scoped>
@import '../../public/chris.css';

.excelBox {
padding-top: 15px;
padding-bottom: 15px;
padding-left: 5px;
padding-right: 5px;
text-align: center;

}

.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }

.icons-center {
vertical-align: middle;
margin-right: 10px;
}

.inputBox {
border: 1px solid #cacbcc;
border-radius: 5px;
color: #29303b;
font-size: 18px;
height: auto;
line-height: 1.5em;
padding: 5px 5px 5px 5px;
margin-top: 5px;
}

.inputBox:hover {

border: 2px solid #448aff;
border-radius: 5px;
color: #29303b;
font-size: 18px;
height: auto;
line-height: 1.5em;
padding: 6px 6px 6px 6px;
margin-top: 5px;
background-color: #e0eff7;
  
}

  .inputBoxOutbound {
    border: 1px solid #cacbcc;
    border-radius: px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }

  .inputBoxOutbound:hover {
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 12px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
    background-color: #e0eff7;
  }


/* .selected {
 background: #726a95;
} */

.tableW {
height: 40px;
}

.center {
text-align: center;
}

tr:hover {
background: #c8e6f5;
}

.headerCenter {
text-align: center;
}


.modal {
 background-color: #29303b;
  border-radius: 5px;
}
.modalTitle {
font-weight: normal;
font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
font-weight: 500;
color: white;
font-family: Poppins, sans-serif;
margin-bottom: 0.5rem;
line-height: 1.6;
}

.md-menu {
padding: 0;
padding: 0;

}

.custButton {
margin: 10px;
width: 120px;
height: 40px;
line-height:40px;
font-size: 0.8rem;

}

.custMenuButton {

width: 110px;
height: 40px;
line-height:45px;
font-size: 0.9rem;
align-self: center;

}

.custSearchBar{
  margin: 10px;
width: 200px;
height: 40px;
line-height:40px;
font-size: 0.9rem;
}


.custButtonRight {
margin: 10px;
width: 100px;
height: 40px;
float : right;
}

.inputBoxSpace {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 200px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }

.inputBoxDouble {
    /* border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px; */
    width: 400px;
    justify-content: space-around;
    display: flex;
  flex-direction: row;
  }

  .icon1 {
    float: right;
    margin: 5px;
}

.inputBoxSpaceWide {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    width: 400px;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
  }
  .result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: auto;
    padding: 10px;
    height: auto;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
}
.result-included-inner-div {
    margin-left: 5px;
    font-weight: bold;
    margin-bottom: -25px;
}
.result-included-div-span {
    margin-left: 100px; 
    margin-top: -10px;
}
.result-included-span {
    margin-left: 5px;
}
</style>

<script>
/* eslint-disable no-plusplus */
import { mapGetters } from 'vuex';
import dateFormat from '../utils/dateFormat';
//import api from "../api";
import { newAPIPost } from '../api/index.js';
import parseXls from "../utils/parseXls";
import callingApiCenter from "../components/CallingApiCenter.vue";
import sort from "fast-sort";

const getInitSearch = () => ({

  //driverMobile: null,
  sendDate: {
    startDate: null,
    endDate: null,
  },
  containMsg: null,
  shortId: null,
  driverMobile: null,
});

const getInitialSMSLog = () => ({
  loadKey: null,
  driverMoible: null,
  shortId: null,
  inboundShipment: null,
  containerNo: null,
  message: null,
  status: null,
  sendDate: null,
  messageId: null,
  createdAt: null,
  createdBy: null,
  updatedAt: null,
  updatedBy: null,
});

export default {

data: () => ({
  searchRequest: getInitSearch(),
  smslogForm: getInitialSMSLog(),
  active: true,
  isFilterModalShowing:false,
  items:[],
  drivers: [],
  smslog:[],
  sortStatus: null,
  startdate: null,
  enddate: null,
  getLog: [],
}),


components: {
  callingApiCenter,
},

watch: {
  getSTCSMSLog(val) {
    this.updateItems(val);
  },
},

computed: {
...mapGetters([
    'getPermission',
    'getUserProfile',
    'getRole',
     'getSTCSMSLog'
  ]),

  filteredRows(){
        return _(this.items).sortBy((it) => {it.sendDate});
      },

  getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

  getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },

  canEdit() {
        return this.getSelectedItems.length === 1 ;
      },

  getSMSLog() {
      return this.smslog;
    },  


  getOutboundStatus() {
     return [
        {
          id: 'EPT',
          name: 'EMPTY',
        },
        {
          id: 'LD',
          name: 'LOADED',
        },
        {
          id: 'ASN',
          name: 'Assigned',
        },
        {
          id: 'OU',
          name: 'Outbound',
        },
     ]
  },
},    
async mounted() {
      const alldrivers = await this.$store.dispatch(
          'getDriversBySource',
          {
            defaultSalesOffice: 'LGB',
            driverOffice: 'FSI',
            source: 'OUTBOUND',
          }
      );
      console.log("alldrivers: " + JSON.stringify(alldrivers));
      this.drivers = alldrivers;

    const cachedSearchRequest = this.searchRequest;
    if (cachedSearchRequest && !_(cachedSearchRequest).isEmpty()) {
    this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
  } else {
   this.searchRequest = getInitSearch(this);
  }
  /*
  console.log("this.smslog:" + this.searchRequest);
        //const cachedSearchRequest1 = this.$store.state.gstDriverMaster.searchRequest;
        const cachedSearchRequest1 = this.$store.state.stcSMSLog
        //this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
        this.$el.querySelector('#searchTag').click();
        console.log("this.getSTCSMSLog:" + this.getSTCSMSLog);
        this.updateItems(this.getSTCSMSLog);
        */

},

 methods: {

  // handleStatusChanged(id) {
  //     this.searchRequest.loadStatus = id;
  //     if (id != 'OU')
  //     {
  //       this.searchRequest.gwDate.startDate = null;
  //       this.searchRequest.gwDate.endDate = null;
  //     }
  //   },

  //   handleCarrierChanged(id) {
  //     this.searchRequest.carrier = id;
  //   },

  //   handleWindowsChanged(id) {
  //       this.searchRequest.receivingWindows = id;
  //   },

      handleDriverChanged() {
        return (id, name, unit, weight, plate, trail) => {
          //console.log("itsm driverPh: " + item.driverPh);
          //item.driverPh = "";
          //console.log(`Item is ${item}`)
          //item.moveInBy = id;
          //item.driverPh = name;
          this.searchRequest.shortId = id;
          this.searchRequest.driverMobile = name;
          //this.dataForm.truckLic = plate;
          //console.log(`Phone is ${item.driverPh}`);
          //item.message = "3555";
          //this.$forceUpdate()
          console.log("selected Items shortId: " + name);
          //console.log("selected Items driverPh: " + item.driverPh);
          //console.log("selected item index: " + item.index);
          //if (item.index > -1)
          //{
          //    console.log("selected item driverPh: " + this.smslist[item.index].driverPh);
          //}
          //if (document.getElementById("smsoutbound"))
          //{
          //   console.log("find smsoutbound element");
          //   document.getElementById("smsoutbound").refresh;
         // }
        };
      },

    mouseOver: function(){
        this.active = true;
    },

    mouseLeave: function() {
      this.active = !this.active;
    },

    updateItems(itemsSource) {
          var items = JSON.parse(JSON.stringify(itemsSource));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
        },

    updatesmslog(log) {
      var items = JSON.parse(JSON.stringify(log));
      this.smslog = items;
    },

    doSearch() {
      this.active = false;
      console.log("shortId: " + this.searchRequest.shortId);
      console.log("search msg: " + this.searchRequest.containMsg);

      // console.log("start date: " + formatStartDate(this.searchRequest.sendDate.startDate));
      // console.log("end date: " + formatEndDate(this.searchRequest.sendDate.endDate));
      console.log("original start date: " + this.startdate);
      console.log("original end date: " + this.enddate);
      if (this.startdate != null || this.enddate != null) {
        if (this.enddate == null || this.enddate == ""){
           this.searchRequest.sendDate.endDate = formatEndDate(this.startdate);   
        } else {
           this.searchRequest.sendDate.endDate = formatEndDate(this.enddate);
        }
        if (this.startdate)
           this.searchRequest.sendDate.startDate = formatStartDate(this.startdate);
        if (this.searchRequest.sendDate.startDate > this.searchRequest.sendDate.endDate) {
           alert("Error: Search Start Date is greater than End Date");
           return;
        } 
      } 
      console.log("start date: " + this.searchRequest.sendDate.startDate);
      console.log("end date: " + this.searchRequest.sendDate.endDate);
      //console.log("date format: " + dateFormat(new Date(this.searchRequest.sendDate.startDate), "yyyy-MM-dd'T'HH:mm:ss"))
      if (this.searchRequest.driverMobile && this.searchRequest.driverMobile != "") {
        if (this.searchRequest.driverMobile.substring(0,2) != "+1") {
           if (this.searchRequest.driverMobile.substring(0,1) != "1")
             //console.log("substring driver mobile: " + this.searchRequest.driverMobile.substring(0,1));
             this.searchRequest.driverMobile = "1" + this.searchRequest.driverMobile;
           if (this.searchRequest.driverMobile.substring(0,1) != "+")
             //console.log("substring driver mobile: " + this.searchRequest.driverMobile.substring(0,1));
             this.searchRequest.driverMobile = "+" + this.searchRequest.driverMobile;
        }
      }
      if (this.searchRequest.driverMobile == "")
        this.searchRequest.driverMobile = null;   
      //else
      //   this.searchRequest.driverMobile = "+19095695793";
  
      //this.searchRequest.sendDate.startDate = "2022-01-01T08:00:00";
      //this.searchRequest.sendDate.endDate = "2022-02-28T08:00:00"   

      console.log("this.stcSMSLog:" + this.searchRequest.sendDate.startDate + " " + this.searchRequest.sendDate.endDate + " " + this.searchRequest.driverMobile);
      this.$nextTick(() => {
        this.$store.dispatch('stcSMSLog', this.searchRequest);
      })
    },

    doClear() {
      console.log("doClear::startdate: " + this.startdate);
      _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
          .each((it) => {
            it.click();
            this.searchRequest = getInitSearch();
            if (this.startdate)
               this.startdate = null;
            if (this.enddate)   
               this.enddate = null;
          });
      this.$nextTick(() => {
        //  this.searchRequest = getInitSearch();
        //  if (this.startdate)
        //     this.startdate = null;
        //  if (this.enddate)   
        //     this.enddate = null;
         console.log("doClear::startdate (after): " + this.startdate);
      });
      //this.$forceUpdate();
    },

    filterBar(){
      this.isFilterModalShowing = true;
    },

    async refreshAction(){
        // const req = this.requestdatabackup;
        // this.getInitialSMSLog();
        // if (req != null && req.length > 0)
        // {
        //    req.forEach( (it) => {
        //        this.smslogForm.inbound
        //    }

        //    )
        // }
        // console.log("inboundshipment: " + this.dataForm.inboundShipment);
        //if (document.getElementById("pb"))
        //{
        //   document.getElementById("pb").style.display = "";
        //}
        while (this.getLog.length > 0) {this.getLog.pop()}
        this.items.forEach( (it) => {
           console.log("InboundShipment in loop: " + it.inboundShipment);
           this.smslogForm = getInitialSMSLog();
           this.smslogForm.inboundShipment = it.inboundShipment;
           console.log("actual loadKey: " + it.loadKey);
           this.smslogForm.loadKey = it.loadKey;
           this.smslogForm.messageId = it.messageId;
           this.smslogForm.sendDate = it.sendDate;
           console.log("smslogForm: " + this.smslogForm.inboundShipment);
           this.getLog.push(this.smslogForm)
        })

        console.log("smslogForm size: " + this.getLog.length);
        //const refreshLog = api.post('/api/w/SendSMS/RefreshLog', {smsInfo: this.getLog})
        const refreshLog = newAPIPost('/api/w/SendSMS/RefreshLog', {smsInfo: this.getLog})
        .then((it) => {
          console.log("messageId: " + it[0].messageId + " and size: " + it.length);
          //this.smsLog = it;
          this.items = it;
          //if (document.getElementById("pb"))
          //{ 
          //   document.getElementById("pb").style.display = "none";
          //}
        }
        )
     },

    handleScroll(e) {
       $(this.$el.querySelector('.table-header'))
       .offset({
          left: -1 * (e.target.scrollLeft - $('.outer-container')
           .offset().left),
      });
    },

    // getMaxId() {
    //   return '100008';
    // },

//     sortFunction(sortFiled){
//       //const sorted = sort(this.items).asc(sortFiled);
//       const sorted = _(this.items).sortBy(sortFiled);
//       this.sortStatus = !this.sortStatus;
//       console.log(this.sortStatus)
//       console.log(this.smslog)
//     if (this.sortStatus)
//       {
//         this.items = sorted;
//       }
//     else
//       {
//       this.items = sorted.reverse();
//     }
            
// },

         sortFunction(sortFiled){
                const sorted = _(this.items).sortBy(sortFiled);
                console.log(this.sortStatus);
                this.sortStatus = !this.sortStatus;
                if (this.sortStatus == "ASCENDING" || this.sortStatus == null)
                {
                    this.items = sorted;
                }
                else
                {
                    this.items = sorted.reverse();
                }
                
          },


},
}
function formatStartDate(date) {
  if (date) {
     var year = date.getFullYear();
     var month = date.getMonth();
     var day = date.getDate();
     month += 1;
     if (month < 10)
        month = "0" + month;
     if (day < 10)
        day = "0" + day;
     return year + "-" + month + "-" + day + "T00:00:00";
  } else {
     return "";
  }
}
function formatEndDate(date) {
  console.log("formatEndDate::date: " + date);
  if (date) {
     var year = date.getFullYear();
     var month = date.getMonth();
     var day = date.getDate();
     month += 1;
     if (month < 10)
        month = "0" + month;
     if (day < 10)
        day = "0" + day;
     console.log("month: " + month);
     return year + "-" + month + "-" + day + "T23:59:59";
  } else {
     return "";
  }
}
</script>